import { Button, Card, Modal, Flex, Text } from '@mantine/core';

interface ParentNamesModalProps {
  close: () => void;
  itemName: string;
  opened: boolean;
  parentNames: string[];
}

export default function ParentNamesModal({
  close,
  itemName,
  opened,
  parentNames,
}: ParentNamesModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={close}
      title={`Parent${parentNames.length > 1 ? 's' : ''} for ${itemName}`}
      size="lg"
    >
      <Card variant="outlined">
        {parentNames.map((name, index) => (
          <Flex
            mb={index === parentNames.length - 1 ? undefined : 'md'}
            pt={index === 0 ? undefined : 'md'}
            // eslint-disable-next-line react/no-array-index-key
            key={`${name}-${index}`}
            styles={{
              root: {
                borderTop: index === 0 ? undefined : '1px dashed var(--border-secondary)',
              },
            }}
          >
            <Text variant="body-sm">{name}</Text>
          </Flex>
        ))}
      </Card>
      <Button onClick={close} fullWidth mt="md">
        Done
      </Button>
    </Modal>
  );
}
